import { render } from "./publicQuestionsScreen.vue?vue&type=template&id=6f4fc510&scoped=true"
import script from "./publicQuestionsScreen.vue?vue&type=script&lang=js"
export * from "./publicQuestionsScreen.vue?vue&type=script&lang=js"

import "./publicQuestionsScreen.vue?vue&type=style&index=0&id=6f4fc510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4fc510"]])

export default __exports__